<template>
  <v-btn icon @click="toggleSort">
    <v-icon dark v-if="currentSort === 'ASC'">mdi-sort-ascending</v-icon>
    <v-icon dark v-else>mdi-sort-descending</v-icon>
  </v-btn>
</template>

<script>
const { mapMutations } = require('vuex');

export default {
  data: () => ({
    currentSort: 'ASC'
  }),
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    sort() {
      return this.$store.state.AdminUserStore.sort.find((item) => item.datatype === this.datatype)?.sort ?? 'ASC';
    }
  },
  methods: {
    ...mapMutations({
      setSort: 'AdminUserStore/setSort'
    }),
    toggleSort() {
      if (this.currentSort === 'ASC') {
        this.currentSort = 'DESC';
      } else {
        this.currentSort = 'ASC';
      }
    }
  },
  watch: {
    currentSort: {
      handler(newSort) {
        this.setSort({
          datatype: this.datatype,
          sort: newSort
        });
      }
    },
    datatype: {
      async handler() {
        this.currentSort = this.sort;
      },
      immediate: true
    }
  }
};
</script>
